import type {ParameterValue} from "#graph/nodes/graph/helpers"
import {parameterValue} from "#graph/nodes/graph/helpers"
import {z} from "zod/v4-mini"
import type {GraphNodeDefinition} from "#graph/nodes/graph/types"

export type ListParameters<ItemType> = {list: ParameterValue<ItemType>[]}

export const listNodeDefinition = <ItemType>(nodeClass: string, itemSchema: z.ZodMiniType<ItemType>) =>
    ({
        nodeClass,
        validation: {
            returns: z.array(itemSchema),
            parameters: z.object({list: z.array(parameterValue(itemSchema))}),
        },
    }) satisfies GraphNodeDefinition<ItemType[], ListParameters<ItemType>>
